//import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'
//import { Bs1Circle } from "react-icons/bs";
import { AcademicProjectList, HobbyProjectList } from './ProjectList';
import { CVIcon, GithubIcon, LinkedinIcon, MailIcon, ORCIDIcon, ScholarIcon } from './InfoIcon';
import { MidSkills, StrongSkills } from './Skills';



function App() {
  return (
    <div className="App">
      <div style={{fontSize:50, fontWeight:100, paddingTop:10}} className="ColorTop">
        Giuseppe Ciacco
      </div>
      <div style={{fontSize:25, fontWeight:100}} className="ColorTop">
       Software Engineer
      </div>
      <div style={{fontSize:15, fontWeight:100}} className="ColorTop">
        MSc Computer Engineering
      </div>
      <hr style={{color:"#93dbba", marginLeft:"auto", marginRight:"auto", height: 5, width:"65%", alignSelf:"center", marginBottom:10, marginTop:10}} />
      <div style={{paddingBottom:10}}>
        <GithubIcon/>
        <LinkedinIcon/>
        <ScholarIcon/>
        <ORCIDIcon/>
        <MailIcon/>
      </div>
      {/*<div style={{paddingBottom:10}}>
        <CVIcon/>
      </div>*/}
      {/*<div style={{fontSize:15, fontWeight:100, marginTop:2, marginBottom:20}}>
        PORTFOLIO
      </div>*/}

      <div className="">
      <div className="container"  style={{paddingBottom:35}}>
        <h2 style={{fontSize:40, fontWeight:300, marginTop:2, marginBottom:20, paddingTop:14}}>Experiences</h2>

		<div className="row align-items-center how-it-works d-flex" style={{textAlign:"left"}}>
          <div className="col-2 text-center bottom d-inline-flex justify-content-center align-items-center">
            <div className="circle font-weight-bold"><div style={{fontWeight:"bold", fontSize:20, display: "flex", justifyContent:"center", alignItems: "center", width:"60px",height: "60px"}}>    </div></div>
          </div>
          <div className="col-8">
            <h5 className="ColorTop">The MathWorks</h5>
            <h5 className="ColorTop2">Software Engineer<br/> <span style={{fontSize:16}} className="ColorTop3">United Kingdom</span></h5>
            <h6 className="ColorTop3">Dec 2025 - Present</h6>
          </div>
        </div>

        <div className="row timeline">
          <div className="col-2">
            <div className="corner top-right"></div>
          </div>
          <div className="col-8">
            <hr className="bar-timeline"/>
          </div>
          <div className="col-2">
            <div className="corner left-bottom"></div>
          </div>
        </div>

		<div className="row align-items-center justify-content-end how-it-works d-flex" style={{textAlign:"right"}}>
          <div className="col-8 text-right">
            <h5 className="ColorTop">The MathWorks</h5>
            <h5 className="ColorTop2">Engineer in EDG<br/> <span style={{fontSize:16}} className="ColorTop3">United Kingdom</span></h5>
            <h6 className="ColorTop3">Nov 2024 - Nov 2025</h6>
          </div>
          <div className="col-2 text-center full d-inline-flex justify-content-center align-items-center">
            <div className="circle font-weight-bold"><div style={{fontWeight:"bold", display: "flex", fontSize:20, justifyContent:"center", alignItems: "center", width:"60px",height: "60px"}}>2025</div></div>
          </div>
        </div>

		<div className="row timeline">
          <div className="col-2">
            <div className="corner right-bottom"></div>
          </div>
          <div className="col-8">
            <hr className="bar-timeline"/>
          </div>
          <div className="col-2">
            <div className="corner top-left"></div>
          </div>
        </div>

        <div className="row align-items-center how-it-works d-flex" style={{textAlign:"left"}}>
          <div className="col-2 text-center bottom d-inline-flex justify-content-center align-items-center">
            <div className="circle font-weight-bold"><div style={{fontWeight:"bold", fontSize:20, display: "flex", justifyContent:"center", alignItems: "center", width:"60px",height: "60px"}}>2024</div></div>
          </div>
          <div className="col-8">
            <h5 className="ColorTop">Politecnico di Torino</h5>
            <h5 className="ColorTop2">Research Fellow</h5>
            <h6 className="ColorTop3">Sep 2023 - Oct 2024</h6>
            
            <ul>
              <li style={{fontSize:14}}>Carried out at <a rel="noreferrer" target="_blank" href="http://www.cerl.polito.it/">CERL</a> research group of Politecnico di Torino</li>
              <li style={{fontSize:14}}>Responsibilities:</li>
              <ul>
                <li style={{fontSize:14}}>C++ Programming</li>
                <li style={{fontSize:14}}>Developments in high performance computing (MPI, OpenMP)</li>
                <li style={{fontSize:14}}>Development of new equations and associated algorithmic strategies</li>
              </ul>
              <li style={{fontSize:14}}>Publications:</li>
              <ul>
                <li style={{fontSize:12}}><a rel="noreferrer" target="_blank" href="https://ieeexplore.ieee.org/abstract/document/10352703"><i>Giunzioni, V., Ciacco, G., Henry, C., Merlini, A., & Andriulli, F. P. (2023, November). Linear-in-Complexity Computational Strategies for Modeling and Dosimetry at TeraHertz. In 2023 IEEE Conference on Antenna Measurements and Applications (CAMA) (pp. 950-953). IEEE.</i></a></li>
              </ul>
            </ul>
          </div>
        </div>
        
        <div className="row timeline">
          <div className="col-2">
            <div className="corner top-right"></div>
          </div>
          <div className="col-8">
            <hr className="bar-timeline"/>
          </div>
          <div className="col-2">
            <div className="corner left-bottom"></div>
          </div>
        </div>
        
        <div className="row align-items-center justify-content-end how-it-works d-flex" style={{textAlign:"right"}}>
          <div className="col-8 text-right">
            <h5 className="ColorTop">Politecnico di Torino</h5>
            <h5 className="ColorTop2">MSc Computer Engineering <br/> <span style={{fontSize:16}} className="ColorTop3">Software Course</span></h5>
            <h6 className="ColorTop3">Oct 2021 - Jul 2023</h6>
            <ul style={{direction:"rtl"}}>
              <li style={{fontSize:14}}>Graduated with score <span style={{fontWeight:"bold"}}>110/110 cum Laude</span></li>
              <li style={{fontSize:14}}><span style={{fontWeight:"bold"}}>Master thesis</span> completed at <a rel="noreferrer" target="_blank" href="http://www.cerl.polito.it/">CERL</a> research group of Politecnico di Torino<br/><a style={{fontSize:12}} rel="noreferrer" target="_blank" href="https://webthesis.biblio.polito.it/27664/"><i>Advanced Algorithmic Strategies and Parallel Computational Models for Low and High Frequency Electromagnetics Scenarios</i></a></li>
            </ul>
          </div>
          <div className="col-2 text-center full d-inline-flex justify-content-center align-items-center">
            <div className="circle font-weight-bold"><div style={{fontWeight:"bold", display: "flex", fontSize:20, justifyContent:"center", alignItems: "center", width:"60px",height: "60px"}}>2023</div></div>
          </div>
        </div>
        
        <div className="row timeline">
          <div className="col-2">
            <div className="corner right-bottom"></div>
          </div>
          <div className="col-8">
            <hr className="bar-timeline"/>
          </div>
          <div className="col-2">
            <div className="corner top-left"></div>
          </div>
        </div>
        
        <div className="row align-items-center how-it-works d-flex" style={{textAlign:"left"}}>
          <div className="col-2 text-center top d-inline-flex justify-content-center align-items-center">
            <div className="circle font-weight-bold"><div style={{fontWeight:"bold", display: "flex", fontSize:20, justifyContent:"center", alignItems: "center", width:"60px",height: "60px"}}>2021</div></div>
          </div>
          <div className="col-8">
            <h5 className="ColorTop">Politecnico di Torino</h5>
            <h5 className="ColorTop2">BSc Computer Engineering</h5>
            <h6 className="ColorTop3">Oct 2018 - Jul 2021</h6>
            <ul>
              <li style={{fontSize:14}}>Graduated with score <span style={{fontWeight:"bold"}}>110/110 cum Laude</span></li>
              <li style={{fontSize:14}}><span style={{fontWeight:"bold"}}>Curricular internship</span> carried out at <a rel="noreferrer" target="_blank" href="http://www.cerl.polito.it/">CERL</a> research group of Politecnico di Torino</li>
              <li style={{fontSize:14}}>Attended <span style={{fontWeight:"bold"}}>Young Talent Project</span> (Percorso per Giovani Talenti), <a rel="noreferrer" target="_blank" href="https://bestr.it/award/show/Zs_FusGVS26oEcNwRGTH2g?ln=en">.Bestr Badge</a></li>
            </ul>
            </div>
        </div>

        <div className="row timeline">
          <div className="col-2">
            <div className="corner top-right"></div>
          </div>
          <div className="col-8">
            <hr className="bar-timeline"/>
          </div>
          <div className="col-2">
            <div className="corner left-bottom"></div>
          </div>
        </div>
        
        <div className="row align-items-center justify-content-end how-it-works d-flex" style={{textAlign:"right"}}>
          <div className="col-8 text-right">
            <h5 className="ColorTop">Liceo Scientifico Galileo Ferraris, Torino</h5>
            <h5 className="ColorTop2">Scientific High School</h5>
            <h6 className="ColorTop3">Sep 2013 - Jul 2018</h6>
            <ul style={{direction:"rtl"}}>
              <li style={{fontSize:14}}>Graduated with score <span style={{fontWeight:"bold"}}>100/100 cum Laude</span></li>
              <li style={{fontSize:14}}><span style={{fontWeight:"bold"}}>Honourable mention</span> at National Mathematics Olympics, 2017. <a rel="noreferrer" target="_blank" href="http://olimpiadi.dm.unibo.it/archivio/finali-nazionali/cesenatico-2017/">Final standings</a>, <a rel="noreferrer" target="_blank" href="https://web.archive.org/web/20210127040936/https://olimato.it/cesenatico-2017-i-risultati/">Report</a></li>
            </ul>
          </div>
          <div className="col-2 text-center full d-inline-flex justify-content-center align-items-center">
            <div className="circle font-weight-bold"><div style={{fontWeight:"bold", fontSize:20, display: "flex", justifyContent:"center", alignItems: "center", width:"60px",height: "60px"}}>2018</div></div>
          </div>
        </div>

      </div>

      <hr style={{ width:"80%", marginLeft:"auto", marginRight:"auto", height: 5, alignSelf:"center", marginBottom:2, marginTop:2}} />
      
      <div className="container" style={{paddingBottom:35}}>
        <h2 style={{fontSize:40, fontWeight:300, marginTop:2, marginBottom:40, paddingTop:14}}>Coding skills</h2>
        <div className="row" style={{marginBottom:20}}>
          <div className="column" style={{minWidth:300}}>
            
            <div style={{borderStyle:"solid", borderWidth:2, marginBottom:30, borderColor:"rgba(157, 186, 190, 0.6)", backgroundColor:"rgba(157, 186, 190, 0.1)", borderRadius:5}}>
              <h3 style={{fontSize:27, fontWeight:300, marginTop:6, paddingBottom:2}}>Strong Knowledge</h3>
              <hr style={{ marginLeft:"auto", marginRight:"auto", width:"100%", alignSelf:"center", marginBottom:0, marginTop:5}} />
              <StrongSkills/>
            </div>
          </div>
          <div className="column">
            <div style={{borderStyle:"solid", borderWidth:2, borderColor:"rgba(157, 186, 190, 0.6)", backgroundColor:"rgba(157, 186, 190, 0.1)", borderRadius:5}}>
              <h3 style={{fontSize:27, fontWeight:300, marginTop:6, paddingBottom:2}}>Mid Knowledge</h3>
              <hr style={{ marginLeft:"auto", marginRight:"auto", width:"100%", alignSelf:"center", marginBottom:0, marginTop:5}} />
              <MidSkills/>
            </div>
          </div>
          
        </div>         
        
        
        
      </div>
      
      <hr style={{ width:"80%", marginLeft:"auto", marginRight:"auto", alignSelf:"center", marginBottom:2, marginTop:2}} />
      <div className="container"  style={{paddingBottom:35}} >
        <h2 style={{fontSize:40, fontWeight:300, marginTop:2, marginBottom:40, paddingTop:14}}>Projects - Archive</h2>
              <div style={{borderStyle:"solid", borderWidth:2, borderColor:"rgba(157, 186, 190, 0.6)", backgroundColor:"rgba(157, 186, 190, 0.1)", borderRadius:5}}>
              <h3 style={{fontSize:27, fontWeight:300, marginTop:6, paddingBottom:2}}>Academic Projects</h3>
              <hr style={{ marginLeft:"auto", marginRight:"auto", width:"100%", alignSelf:"center", marginBottom:0, marginTop:5}} />
              <AcademicProjectList/>
            </div>
            <div style={{borderStyle:"solid", borderWidth:2, borderColor:"rgba(157, 186, 190, 0.6)", backgroundColor:"rgba(157, 186, 190, 0.1)", borderRadius:5, marginTop:30}}>
              <h3 style={{fontSize:27, fontWeight:300, marginTop:6, paddingBottom:2}}>Hobby Projects</h3>
              <hr style={{ marginLeft:"auto", marginRight:"auto", width:"100%", alignSelf:"center", marginBottom:0, marginTop:5}} />
              <HobbyProjectList/>  
            </div>
      </div>

      <hr style={{ width:"80%", marginLeft:"auto", marginRight:"auto", alignSelf:"center", marginBottom:2, marginTop:20}} />
      <div className="container">
        
        {/*<hr style={{color:"#93dbba", marginLeft:"auto", marginRight:"auto", height: 5, width:400, alignSelf:"center", marginBottom:2, marginTop:2}} />*/}
        <h5 style={{fontSize:12, fontWeight:100, paddingBottom:10, marginBottom:0, marginTop:20}} className="ColorTop">
          Developed in ReactJS by <a rel="noreferrer" target="_blank" href="https://github.com/ciaccogiuseppe">ciaccogiuseppe</a>
        </h5>
        <h5 style={{fontSize:10, fontWeight:300, marginTop:2, paddingBottom:40, marginBottom:0}}><a href= "mailto:giuseppeciacco.gc@gmail.com">giuseppeciacco.gc@gmail.com</a> </h5>
        
      </div>

    </div>

      
      {/*<header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Test
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
    </header>*/}
    </div>
  );
}

export default App;
